import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=99ceb9ec"
import script from "./Factory.vue?vue&type=script&lang=ts"
export * from "./Factory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports